import AbstractRestApi from '@/api/RestApi/AbstractRestApi'
import ResponseHandler from '@/api/response/ResponseHandler'
import apiClient from '@/api/ApiClient'

class UserAddresses extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/user-addresses'
    }
    savePositions(positions) {
        return ResponseHandler.handle(
            apiClient.post('/api/v1/user/address-position', { positions })
        )
    }
    orderList(id) {
        return ResponseHandler.handle(
            apiClient.get(`/api/v1/user/address-position/${id}`)
        )
    }
}

export default new UserAddresses()
